import type {ReactElement} from 'react';
import {MediaControls} from '@Components/contextual-menu/components/media-controls';
import {cancelImageCrop} from '@EmailMakerReact/lib/email-maker-image-crop-library';
import {ImageCropActions} from '@EmailMakerReact/components/image-crop-actions/image-crop-actions';
import {getEmailImageCropPresetItems} from '@EmailMakerReact/lib/email-maker-image-crop-presets-library';
import {RightPanelOverlayHeader} from '../../components/right-panel-overlay-header/right-panel-overlay-header';
import type {ImageCropViewProps} from './image-crop-view.types';
import styles from './image-crop-view.module.scss';

export function ImageCropView({editor, cropState}: ImageCropViewProps): ReactElement {
  function handleBack(): void {
    cancelImageCrop(editor);
  }

  return (
    <div className={styles.view}>
      <RightPanelOverlayHeader title={window.i18next.t('pmwjs_crop')} backAriaLabel={window.i18next.t('pmwjs_back')} onBack={handleBack} />
      <div className={styles.body}>
        <MediaControls items={getEmailImageCropPresetItems(editor, cropState)} />
      </div>
      <footer className={styles.footer}>
        <ImageCropActions editor={editor} idPrefix="email-maker-crop" isApplyButtonFullWidth />
      </footer>
    </div>
  );
}
